// business http service

import { api } from './api.config.js'

import request from '@/utils/request'

export default {
  weChat: {
    freeAccountLogin () {
      return request({
        url: api.weChat.freeAccountLogin,
        method: 'get',
        data: {}
      })
    },
    discern (data) {
      return request({
        url: api.weChat.discern,
        method: 'post',
        data
      })
    },
    sendCode (data) {
      return request({
        url: api.weChat.sendCode,
        method: 'get',
        data
      })
    },
    checkAuthCode (data) {
      return request({
        url: api.weChat.checkAuthCode,
        method: 'get',
        data
      })
    },
    listAccountbyMobile (data) {
      return request({
        url: api.weChat.listAccountbyMobile,
        method: 'post',
        query: true,
        data
      })
    },
    getInvoiceList (data) {
      return request({
        url: api.weChat.getInvoiceList,
        method: 'get',
        data
      })
    },
    nonVatSaveAndCommit (data) {
      return request({
        url: api.weChat.nonVatSaveAndCommit,
        method: 'post',
        data
      })
    },
    nonVatSave (data) {
      return request({
        url: api.weChat.nonVatSave,
        method: 'post',
        data
      })
    },
    vatSaveAndCommit (data) {
      return request({
        url: api.weChat.vatSaveAndCommit,
        method: 'post',
        data
      })
    },
    vatSave (data) {
      return request({
        url: api.weChat.vatSave,
        method: 'post',
        data
      })
    },
    nonVatUpdate (data) {
      return request({
        url: api.weChat.nonVatUpdate,
        method: 'put',
        data
      })
    },
    nonVatCommit (data) {
      return request({
        url: api.weChat.nonVatCommit,
        method: 'put',
        data
      })
    },
    nonVatEditAndCommit (data) {
      return request({
        url: api.weChat.nonVatEditAndCommit,
        method: 'put',
        data
      })
    },
    nonVatDel (data, params) {
      return request({
        url: api.weChat.nonVatDel,
        method: 'delete',
        data,
        params
      })
    },
    vatUpdate (data) {
      return request({
        url: api.weChat.vatUpdate,
        method: 'put',
        data
      })
    },
    vatCommit (data) {
      return request({
        url: api.weChat.vatCommit,
        method: 'put',
        data
      })
    },
    vatEditAndCommit (data) {
      return request({
        url: api.weChat.vatEditAndCommit,
        method: 'put',
        data
      })
    },
    vatDel (data, params) {
      return request({
        url: api.weChat.vatDel,
        method: 'delete',
        data,
        params
      })
    },
    getNonVat (data, params) {
      return request({
        url: api.weChat.getNonVat,
        method: 'get',
        data,
        params
      })
    },
    getVat (data, params) {
      return request({
        url: api.weChat.getVat,
        method: 'get',
        data,
        params
      })
    },
    vatCheck (params) {
      return request({
        url: api.weChat.vatCheck,
        method: 'put',
        data: {},
        params
      })
    },
    getOffiaccountSignature (data) {
      return request({
        url: api.weChat.getOffiaccountSignature,
        method: 'get',
        data
      })
    }
  }
}
